module.exports = __webpack_public_path__ + "way2go/static/config/home_pbr.svg";